export default __webpack_public_path__ + "static/media/cta-pixel-union.fa334e8d.svg";